<template>
  <div ref="hanacard" class="affiliate-hanacard"></div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  methods: {
    ...mapActions(['setTopAffiliate']),
  },
  mounted() {
    /*
    this.$nextTick(() => {
      const postscribe = require('postscribe');
      const hanacardEl = this.$refs.hanacard;
      postscribe(
        hanacardEl,
        '<script src="//www.hanacard.co.kr/js/travel_wa.js" charset="EUC-KR"><\/script>',
        {
          autoFix: false,
          done: () => {
            $('#mega_gnb .dep2 > li > a').bind('mouseover focusin',function(){
              if($(this).next().hasClass('dep3')) {
                $(this).parent('li').siblings().find('.dep3').hide();
                $(this).next('#mega_gnb .dep3').show();
              } else {
                $(this).parent('li').siblings().find('.dep3').hide();
              }
            });
            $('#mega_gnb .dep2').mouseleave(function(){
              $(this).find('.dep3').hide();
            });
            this.setTopAffiliate(hanacardEl.clientHeight);
          },
        }
      );
    });
    */
  },
}
</script>
<style lang="scss" scoped>
.affiliate-hanacard {
  overflow: hidden;
  position: relative;
  height: 190px;

  &.scroll-up {
    transition: background-color 0.5s, margin-top $duration;
  }

  &::after {
    content: '';
    display: block;
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
    background-color: #fff;
  }

  &::v-deep .header_wrap {
    z-index: 2;
  }
}
</style>
